import axios from 'axios';

// Create a custom instance of axios
const axiosInstance = axios.create({
    baseURL: 'https://api-native.pages.dev',
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to handle auth token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor for error handling
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('token');
            window.location.href = '/#/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 